<template>
  <div>
    <div class="container-fluid">
      <div class="heightcontainer">
        <div class="nav-height">
          <nav class="navbar-default navbar-fixed-top">
            <div class="col d-flex">
              <div class="col-6 mr-auto pl-6 mt-3">
                <img src="../assets/Logo.svg" alt="logo"/>
              </div>
              <div class="mt-3 p-2">
                <router-link to="/signup" tag="a">
                  <img src="../assets/SignUp.svg" alt="signup"/>
                </router-link>
              </div>
              <div class="mt-4 mr-3">
                <router-link to="/signup" class="header-font-size" tag="a"
                  >Sign Up</router-link
                >
              </div>
              <div class="mt-3 p-2">
                <router-link to="/signin" tag="a">
                  <img src="../assets/SignIn.svg" alt="signin"/>
                </router-link>
              </div>
              <div class="mt-4 mr-3">
                <router-link to="/signin" class="header-font-size" tag="a"
                  >Sign In</router-link
                >
              </div>
              <div class="mt-4 mr-2">
                <router-link to="/help" tag="a">
                  <img src="../assets/Help.svg" alt="help"/>
                </router-link>
              </div>
              <div class="mr-5 mt-4">
                <router-link to="/help" class="header-font-size" tag="a"
                  >Help</router-link
                >
              </div>
            </div>
          </nav>
        </div>
        <div class="landing-background-color">
          <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
            <div
              class="col d-flex justify-content-end align-items-center ml-3 mt-3"
            >
              <router-link to="/video" tag="a">
                <img src="../assets/Video.svg" alt="video"/>
              </router-link>
              <div class="page-font-size">
                <label class="ml-2">Post A Video</label>
              </div>
            </div>
            <div class="d-flex align-items-center p-4 mt-4">
              <router-link to="/video" tag="a">
                <img src="../assets/PostJob.svg" alt="postjob"/>
              </router-link>

              <div class="page-font-size">
                <label class="ml-2">Post A Job</label>
              </div>
            </div>
          </div>
          <div class="row row-cols-lg-2 p-2">
            <div class="col d-flex flex-column connecting-job-seeke">
              <p
                class="col-lg-1 col-md-1 col-sm-1 d-flex paragraphspacing pl-6"
              >
                Connecting
              </p>
              <p class="col paragraphspacing ml-5">job seekers and employers</p>
              <p class="col paragraphspacing ml-5">faster, easier & smarter.</p>
            </div>
            <div class="col">
              <div class="col d-flex">
                <div class="col col-lg-2">
                  <label class="page-font-size">People</label>
                </div>
                <div class="col col-lg-2">
                  <label class="page-font-size">Company</label>
                </div>
                <div class="col col-lg-2">
                  <label class="page-font-size">Job</label>
                </div>
              </div>

              <div class="input-group md-form form-sm form-1 pl-0">
                <div class="input-group-prepend">
                  <span class="input-group-text" id="basic-text1">
                    <img src="../assets/Search.svg" alt="search"/>
                  </span>
                </div>
                <input
                  class="form-control"
                  type="text"
                  placeholder="Search"
                  aria-label="Search"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-cols-lg-2 p-2">
        <div class="d-flex justify-content-start">
          <img
            class="pre-login-illustration"
            src="../assets/PreLogin_Illustration.svg"
            alt="illustration"
          />
        </div>
      </div>
      <div class="row row-cols-lg-6 row-cols-md-4 row-cols-sm-2 p-2">
        <div class="p-4">
          <img src="../assets/SuggestiveJobs.svg" alt="suggestivejobs"/>
        </div>
      </div>
    </div>

    <BottomFooter></BottomFooter>
  </div>
</template>
<script>
import BottomFooter from "@/components/BottomFooter.vue";

export default {
  components: {
    BottomFooter
  },
  data() {
    return {
      newpassword: "Enter New Password",
      confirmpassword: "Enter Confirm Password *",
      newpassword: "",
      cpassword: "",
      show: false,
      signup: "Candidate",
      Candidate: "Candidate",
      Recruiter: "Recruiter",
      verificationdetails: true,
      terms: false,
      message: "",
      getotpdetails: false,
      emailidverification: true
    };
  },
  methods: {
    fetchdata() {},
    switchVisibility() {
      const passwordField = document.querySelector("#password");
      if (passwordField.getAttribute("type") === "password")
        passwordField.setAttribute("type", "text");
      else passwordField.setAttribute("type", "password");
    },
    emailidverified() {
      this.message = "EmailIDVerified";
      if (this.message === "EmailIDVerified") {
        this.verificationdetails = true;
        this.getotpdetails = true;
        this.emailidverification = false;
      }
    },
    toggle() {
      this.show = !this.show;
    },
    backtosignup() {
      this.getotpdetails = false;
      this.verificationdetails = true;
      this.message = "";
    },
    /* hideModal() {
        this.$refs['my-modal'].hide()
      },
           showModal() {
        this.$refs['my-modal'].show()
      },*/
    getotp() {
      this.message = "gotOTP";
      if (this.message === "gotOTP") {
        this.verificationdetails = false;
        this.getotpdetails = true;
      }
    }
  },
  mounted: function() {
    this.fetchdata();
    //this.showModal()
  },
  computed: {
    isDisabled: function() {
      return !this.terms;
    }
  }
};
</script>
<style scoped>
@import "https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css";
</style>
